import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { urlAt } from "@/fieldops/context/NavHistoryContext";

// Record-page breadcrumb. A list segment steps Back when the previous history entry is that
// list (so its filters + scroll come back exactly); otherwise it opens the list fresh.
// trail: [{ label, to? | dropParam?, onClick?, match?(prevUrl: URL), testId? }] — the last item is the
// record itself (a trail ending in a link gets a trailing chevron). dropParam: the list is this same URL without that query param (records opened in place).
export default function Breadcrumbs({ trail, className = "" }) {
  const navigate = useNavigate();
  const go = (c) => {
    if (c.onClick) return c.onClick();
    if (c.dropParam) {
      const here = new URL(window.location.href);
      here.searchParams.delete(c.dropParam);
      c = { ...c, to: here.pathname + here.search,
            match: c.match || ((u) => u.pathname === here.pathname && !u.searchParams.has(c.dropParam)) };
    }
    const idx = window.history.state?.idx ?? 0;
    const prev = idx > 0 ? urlAt(idx - 1) : null;
    const target = new URL(c.to, window.location.origin);
    const p = prev ? new URL(prev, window.location.origin) : null;
    if (p && (c.match ? c.match(p) : p.pathname === target.pathname)) navigate(-1);
    else navigate(c.to);
  };
  return (
    <nav aria-label="Breadcrumb" className={`flex min-w-0 items-center gap-1 text-xs text-gray-500 ${className}`} data-testid="breadcrumbs">
      {trail.map((c, i) => {
        const last = i === trail.length - 1 && !(c.to || c.dropParam || c.onClick);
        return (
          <React.Fragment key={i}>
            {i > 0 && <ChevronRight className="h-3 w-3 shrink-0 opacity-60" />}
            {last ? (
              <span className="truncate font-medium text-gray-800 dark:text-gray-200" data-testid="breadcrumb-current">{c.label}</span>
            ) : (
              <button type="button" onClick={() => go(c)} data-testid={c.testId || `breadcrumb-${i}`}
                      className="shrink-0 hover:text-[#007BFF] hover:underline">{c.label}</button>
            )}
            {i === trail.length - 1 && !last && <ChevronRight className="h-3 w-3 shrink-0 opacity-60" />}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
